import { createApiInstance } from './ApiConfig';

// Create axios instance with base configuration
const api = createApiInstance();

// IMU OTA Target Management APIs

export const listImuOtaTargets = async () => {
  return api.get('/imu/ota/devices');
};

export const setImuOtaTarget = async (serialNumber, targetVersion) => {
  const formData = new FormData();
  // Empty string clears the target on the backend
  formData.append('target_version', targetVersion || '');

  return api.post(`/imu/ota/devices/${encodeURIComponent(serialNumber)}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteImuOtaTarget = async serialNumber => {
  return api.delete(`/imu/ota/devices/${encodeURIComponent(serialNumber)}`);
};

// Firmware Package Management APIs

export const listImuFirmwares = async () => {
  return api.get('/imu/ota/firmwares');
};

// The version is read by the backend from the package's "version" field
export const uploadImuFirmware = async (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);

  return api.post('/imu/ota/firmwares/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const deleteImuFirmware = async version => {
  return api.delete(`/imu/ota/firmwares/${encodeURIComponent(version)}`);
};

// Decoded binary downloads (same endpoints the IMU updater uses)

export const downloadImuFirmwareBinary = async version => {
  return api.get('/imu/ota/get_firmware_binary', {
    params: { version },
    responseType: 'blob',
  });
};

export const downloadImuSignatureBinary = async version => {
  return api.get('/imu/ota/get_signature_binary', {
    params: { version },
    responseType: 'blob',
  });
};
